/**
 * @Description:
 * @author WZP
 * @date 2021/8/25
 */

import AcIcon from 'ac-components/ac-icon';
import classNames from 'classnames/bind';
import { toast } from 'components/dialogs';
import PageContainer from 'containers/en/page-container';
import copy from 'copy-to-clipboard';
import { useTranslation } from 'hooks/use-translation';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import styles from './styles.scss';

const cx = classNames.bind(styles);


function BecomeTutors(props: Record<string, any>) {
	const [modalIsOpen, setModalIsOpen] = useState(false)
	const emailAddr = 'tutor@air-class.com'
	const { transData, t } = useTranslation('becomeTutors');
	useEffect(function () {
		Modal.setAppElement('#app')
	}, [])

	function jumpToRecruit() {
		setModalIsOpen(true)
	}

	function closeModal() {
		setModalIsOpen(false)
	}

	function copyEmailAddr() {
		toast({
			message: t('inviteFriends.alert.success1')
		});
		copy(emailAddr);
	}

	return (
		<PageContainer>
			<Modal
				isOpen={modalIsOpen}
				overlayClassName={cx('join-us-modal-overlay')}
				className={cx('join-us-modal-content')}
			>
				<div>
					<AcIcon className='close' icon='icon_close' onClick={closeModal} />
					<p>{`${transData.dialog}${emailAddr}`}</p>
					<button onClick={copyEmailAddr}>{transData.copy}</button>
				</div>
			</Modal>
			<div className={cx('become-tutors')}>
				<div className={cx('banner-wrap')}>
					<div className={cx('text-wrap')}>
						<h1>{transData.h1}</h1>
						<h2>{transData.h2}</h2>
						<p>{transData.p}</p>
					</div>
					<img
						loading="lazy"
						src="https://web-data.zmlearn.com/image/dmxmU6ih92N26VkskQdCQw/VCG21gic12756773%402x%20(2)%20(1).png"
						alt=""
					/>
				</div>

				<div className={cx('icon-list')}>
					<div>
						<img
							loading="lazy"
							src="https://web-data.zmlearn.com/image/wXnA5pDxfCu2SXSNCE6hvc/icon%EF%BC%8FFlexible%402x%20(1).png"
							alt=""
						/>
						<p>{transData.flexible}</p>
					</div>
					<div>
						<img loading="lazy" src="https://web-data.zmlearn.com/image/8EPtVio63mLpu8CpN3YbTE/Fulfilling%402x%20(1).png" alt="" />
						<p>{transData.ful}</p>
					</div>
					<div>
						<img loading="lazy" src="https://web-data.zmlearn.com/image/rE2YHKC7rcLRY2PAhdJ7sF/High%20Salary%402x%20(1).png" alt="" />
						<p>{transData.high}</p>
					</div>
				</div>

				<button onClick={jumpToRecruit}>{transData.apply}</button>

				<div className={cx('divider')} />
			</div>
		</PageContainer>
	);
}

export default BecomeTutors;
